/**
 * Lazy route chunk factories — used only by App.jsx (React.lazy).
 * Kept separate from prefetch helpers to avoid Rollup TDZ / circular init in the main bundle.
 */
export const dashboardChunk = () => import('./Dashboard.jsx')
export const projectChunk = () => import('./Project.jsx')
export const settingsChunk = () => import('./Settings.jsx')
export const tokenGroupChunk = () => import('./TokenGroup.jsx')
export const logsChunk = () => import('./Logs.jsx')
export const knowledgeBaseChunk = () => import('./KnowledgeBase.jsx')
export const warmupChunk = () => import('./Warmup.jsx')
export const exchangeDistributorChunk = () => import('./ExchangeDistributor.jsx')
export const exchangeDistributorSettingsChunk = () => import('./ExchangeDistributorSettings.jsx')

// CEX-only pages
export const cexDashboardChunk = () => import('./cex/Dashboard.jsx')
export const cexTokensChunk = () => import('./cex/Project.jsx')
export const cexTokenGroupChunk = () => import('./cex/TokenGroup.jsx')
export const cexExchangesChunk = () => import('./cex/Exchanges.jsx')
export const cexAlgorithmsChunk = () => import('./cex/Algorithms.jsx')
export const cexBotsChunk = () => import('./cex/BotMonitor.jsx')
export const cexTerminalChunk = () => import('./cex/Terminal.jsx')
